<template>
  <div class="pdfvuer">
   <iframe
    v-if="url_pdf"
    :src="`https://docs.google.com/gview?url=${url_pdf}&embedded=true`"
    style="width:100%; height:100%;"
    frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  props: {
    url_pdf: { type: String }
  }
};
</script>

<style lang="css" scoped>
/* Page content */
.content {
  padding: 10px;
}

.pdfvuer {
  height: 100%;
}
</style>